import { useContext } from 'react';
import PropTypes from 'prop-types';
import { LocalizationContext } from '@vp/om-translations';

const RequireTranslations = ({ group, keys, children }) => {
  const { activeTranslationDictionary } = useContext(LocalizationContext);

  if (activeTranslationDictionary[group]) {
    for (const key of keys) {
      if (!activeTranslationDictionary[group][key]) {
        return null;
      }
    }
  }
  return children;
};

RequireTranslations.propTypes = {
  dictionary: PropTypes.string,
  message: PropTypes.string,
};

export default RequireTranslations;
